import { z } from 'zod'

export const CRM_UPLOADS_WRITE_CONTRACT_VERSION = '1.0.0' as const

const envelope = z.object({
  contract_version: z.string().min(1),
}).passthrough()

export const crmUploadIssueResponseSchema = envelope
export const crmUploadCompleteResponseSchema = envelope

export type CrmUploadIssueResponse = z.infer<typeof crmUploadIssueResponseSchema>
export type CrmUploadCompleteResponse = z.infer<typeof crmUploadCompleteResponseSchema>
